import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import LrapEnrollmentWizard from 'tio-employee/components/lrap/enrollment/wizard';
import PageHeader from 'tio-ui/components/page-header';
import type { AuthenticatedSlrLrapEnrollmentRouteModel } from 'tio-employee/routes/authenticated/slr/lrap/enrollment';

interface LrapEnrollmentRouteSignature {
  Args: {
    model: AuthenticatedSlrLrapEnrollmentRouteModel;
  };
}

const LrapEnrollmentRouteComponent: TOC<LrapEnrollmentRouteSignature> = <template>
  <div class="tio-col-tight">
    <PageHeader @title={{t "lrap.enrollment.page_title"}} @sticky={{false}} />
    <LrapEnrollmentWizard @person={{@model.person}} />
  </div>
</template>;

export default LrapEnrollmentRouteComponent;
